module.exports = __webpack_public_path__ + "media/images/history/tacova3-27412b11179a3d2b4b846ad70a694c40.jpg";